import { render, staticRenderFns } from "./VerifyDataForm.vue?vue&type=template&id=705d5faa"
import script from "./VerifyDataForm.vue?vue&type=script&lang=js"
export * from "./VerifyDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports